import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import api from "../Services/api";
import apiComunicacao from "../Services/apiComunicacao";
import { app_base_url, app_server } from "../Utils/baseUrl";
import {
  funcionarioCartoriotokenKey,
  funcionarioCartorioKey,
} from "../Utils/localStorageKeys";
import { useCartorio } from "./cartorio";

export interface IFuncionarioCartorio {
  ID: number;
  NOME: string;
  CPF: string;
  EMAIL: string;
  FONE: string;
  WHATS: string;
  SENHA: string;
  CARTORIO_ID: number;
  ATIVO: "A" | "I";
  AVALIAR: "S" | "N";
}
export interface IFuncionarioCartorioList {
  ENTIDADE: string;
  ID: number;
  NOME: string;
  CPF: string;
  EMAIL: string;
  FONE: string;
  WHATS: string;
  ATIVO: string;
  PREFEITURA_ID?: number;
  CARTORIO_ID?: number;
}

interface IFuncionarioCartorioContextData {
  getfuncionariosCartorio(cartorioId: number): Promise<void>;
  funcionariosCartorio: IFuncionarioCartorio[];
  addCartoroFuncionarioCartorio(funcionario: IFuncionarioCartorio): void;
  atualiza(funcionario: IFuncionarioCartorio): void;
  signIn(id: number, senha: string): Promise<void>;
  funcionarioCartorio: IFuncionarioCartorio;
  funcionarioCartorioIsLogged: boolean;
  handleSetFuncionarioCartorio(param: IFuncionarioCartorio): void;
  signOutFuncionarioCartorio(): void;
  checarTokenFuncionario(): Promise<void>;
  helpSignInHashFuncionarioCartorio(): void;
}

interface IFuncionarioCartorioProviderProps {
  children: ReactNode;
}

const FuncionarioCartorioContext = createContext(
  {} as IFuncionarioCartorioContextData
);

function FuncionarioCartorioProvider({
  children,
}: IFuncionarioCartorioProviderProps) {
  const [funcionariosCartorio, setfuncionariosCartorio] = useState(
    [] as IFuncionarioCartorio[]
  );

  const [funcionarioCartorio, setfuncionarioCartorio] = useState(
    {} as IFuncionarioCartorio
  );
  const { getCartorio } = useCartorio();
  useEffect(() => {
    checarTokenFuncionario();
    if (funcionarioCartorio.ID) getCartorio(funcionarioCartorio.CARTORIO_ID);
  }, [funcionarioCartorio.ID]);
  const [
    funcionarioCartorioIsLogged,
    setFuncionarioCartorioIsLogged,
  ] = useState(false);

  async function signIn(id: number, senha: string) {
    try {
      const { data } = await api.post(`/funcionario-cartorio/signIn`, {
        id,
        senha,
      });
      localStorage.setItem(
        funcionarioCartorioKey,
        JSON.stringify(data.funcionario)
      );
      localStorage.setItem(funcionarioCartoriotokenKey, data.token);
      api.defaults.headers.common["Authorization"] = `Bearer ${data.token}`;
      apiComunicacao.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${data.token}`;
      setfuncionarioCartorio(data.funcionario);
      setFuncionarioCartorioIsLogged(true);
    } catch (error) {
      throw error;
    }
  }

  async function checarTokenFuncionario() {
    const token = localStorage.getItem(funcionarioCartoriotokenKey);
    const getFuncionario = localStorage.getItem(funcionarioCartorioKey);
    try {
      if (token && getFuncionario) {
        api.defaults.headers.common["Authorization"] = `Bearer ${token}`;

        await api.get("/checa-token");
        handleSetFuncionarioCartorio(JSON.parse(getFuncionario));
        setFuncionarioCartorioIsLogged(true);
      }
    } catch (error) {
      //Se estiver invalido o token eu valido ele
      // window.alert(error);
      if (funcionarioCartorio.ID) {
        // window.alert(funcionarioCartorio + " token:" + token);
        await signInSenhaHash();
      } else {
        // window.alert("NAO TEM: " + funcionarioCartorio + " token:" + token);
        signOutFuncionarioCartorio();
        throw "Token Inválido!";
      }
    }
  }

  async function signOutFuncionarioCartorio() {
    try {
      localStorage.removeItem(funcionarioCartoriotokenKey);
      localStorage.removeItem(funcionarioCartoriotokenKey);

      setfuncionarioCartorio({} as IFuncionarioCartorio);
      setFuncionarioCartorioIsLogged(false);

      window.location.href = `${app_server}${app_base_url}/cartorio/funcionario`;
    } catch (error) {
      throw error;
    }
  }

  function handleSetFuncionarioCartorio(param: IFuncionarioCartorio) {
    setfuncionarioCartorio(param);
    localStorage.setItem(funcionarioCartorioKey, JSON.stringify(param));
  }

  async function signInSenhaHash() {
    const getFuncionario = localStorage.getItem(funcionarioCartorioKey);
    if (getFuncionario != null) {
      setfuncionarioCartorio(JSON.parse(getFuncionario));
      if (funcionarioCartorio) {
        //window.alert(funcionarioCartorio.ID + " " +funcionarioCartorio.SENHA )
        try {
          const { data } = await api.post(
            `/funcionario-prefeitura/signInHash`,
            {
              id: funcionarioCartorio.ID,
              senha: funcionarioCartorio.SENHA,
            }
          );

          api.defaults.headers.common["Authorization"] = `Bearer ${data.token}`;
          setfuncionarioCartorio(data.funcionario);
          setFuncionarioCartorioIsLogged(true);
        } catch (error) {
          signOutFuncionarioCartorio();
          throw error;
        }
      }
    }
  }

  async function getfuncionariosCartorio(cartorioId: number) {
    try {
      const { data } = await api.get(`/funcionario-cartorio/${cartorioId}`);
      setfuncionariosCartorio(data);
    } catch (error) {
      throw error;
    }
  }

  function addCartoroFuncionarioCartorio(funcionario: IFuncionarioCartorio) {
    setfuncionariosCartorio((prevState) => [...prevState, funcionario]);
  }

  function atualiza(funcionario: IFuncionarioCartorio) {
    setfuncionariosCartorio(
      funcionariosCartorio.map((item) => {
        if (item.ID == funcionario.ID) {
          return funcionario;
        }

        return item;
      })
    );
  }
  function helpSignInHashFuncionarioCartorio() {
    signInSenhaHash();
  }
  return (
    <FuncionarioCartorioContext.Provider
      value={{
        getfuncionariosCartorio,
        funcionariosCartorio,
        addCartoroFuncionarioCartorio,
        atualiza,
        funcionarioCartorio,
        funcionarioCartorioIsLogged,
        signIn,
        handleSetFuncionarioCartorio,
        signOutFuncionarioCartorio,
        checarTokenFuncionario,
        helpSignInHashFuncionarioCartorio,
      }}
    >
      {children}
    </FuncionarioCartorioContext.Provider>
  );
}

function useFuncionarioCartorio() {
  const context = useContext(FuncionarioCartorioContext);

  return context;
}

export { FuncionarioCartorioProvider, useFuncionarioCartorio };
